import styled from "styled-components";

export const TableDiv = styled.div`
    margin-bottom: 5rem;
`